<template>
<div>
  <ItpWidgetCard
    class="mb-3"
  >
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'Selling prices'|pgettext('ProductPrices') }}
      </strong>
      <ItpButton
        :text="'Add price...'|pgettext('ProductPrices')"
        variant="light"
        size="sm"
        class="ml-auto"
        @click.prevent.stop="evh_3343864469950044_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup
      v-if="loaded"
    >
      <BListGroupItem
        v-if="!sellingPrices.length"
      >
        <span>
          {{ 'No prices.'|pgettext('ProductPrices') }}
        </span>
      </BListGroupItem>
      <BListGroupItem
        :key="item.id"
        class="d-flex flex-column"
        v-for="item in sellingPrices"
      >
        <ItpBox
          alignItems="start"
        >
          <ItpIcon
            :icon="item.is_purchase_price ? 'icons8:buy' : 'material-symbols:sell-outline'"
          >
          </ItpIcon>
          <ItpBox
            direction="column"
            class="w-100"
          >
            <ItpBox
              class="W-100"
            >
              <ItpBox
                class="col-md-3"
              >
                <ItpText
                  :strikethrough="item.inactive"
                  class="font-weight-bold mr-3"
                >
                  {{ item.price|number }} {{ item.currency }}
                </ItpText>
                <UcTariffCodeBadge
                  :value="item.tariff_code"
                  class="mr-3"
                  v-if="item.tariff_code"
                >
                </UcTariffCodeBadge>
                <ItpBadge
                  :title="'From quantity'|pgettext('ProductPrice')"
                  no-box-shadow
                  variant="light"
                  class="mr-3 badge-icon border"
                  v-if="item.quantity_from"
                >
                  <ItpIcon
                    name="fa-solid:greater-than-equal"
                  >
                  </ItpIcon>
                  <ItpText
                    :text="item.quantity_from"
                    class="ml-2"
                  >
                  </ItpText>
                  <ItpText
                    :text="product.unit"
                    class="ml-1"
                  >
                  </ItpText>
                </ItpBadge>
                <ItpBadge
                  :title="'Discount price'|pgettext('ProductPrice')"
                  no-box-shadow
                  variant="warning"
                  class="mr-3 badge-icon boredr"
                  v-if="item.is_discount_price"
                >
                  <ItpIcon
                    name="mdi:discount-outline"
                  >
                  </ItpIcon>
                </ItpBadge>
              </ItpBox>
              <ItpBox
                class="col-md-3"
              >
                <UcValidityPeriod
                  :from="item.valid_from"
                  :to="item.valid_to"
                  class="pl-3"
                >
                </UcValidityPeriod>
              </ItpBox>
              <ItpBox
                alignItems="start"
                wrap-items
                class="col-md-6"
              >
                <UcCompactCompanyDisplay
                  :payload="item.partner"
                  class="pl-3"
                  v-if="item.partner"
                >
                </UcCompactCompanyDisplay>
              </ItpBox>
            </ItpBox>
            <ItpBox
              class="W-100"
            >
              <div
                class="col-md-3"
              >
                <ItpText
                  :text="item.note"
                  pre
                  v-if="item.note"
                >
                </ItpText>
              </div>
            </ItpBox>
          </ItpBox>
          <ItpButton
            icon="fa-pen"
            :tooltip="'Edit'|gettext"
            variant="light"
            size="sm"
            class="ml-auto"
            @click.prevent.stop="evh_8855792642156263_clickPreventStop($event, {item})"
          >
          </ItpButton>
        </ItpBox>
      </BListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'Purchase prices'|pgettext('ProductPrices') }}
      </strong>
      <ItpButton
        :text="'Add price...'|pgettext('ProductPrices')"
        variant="light"
        size="sm"
        class="ml-auto"
        @click.prevent.stop="evh_302930856768608_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup
      v-if="loaded"
    >
      <BListGroupItem
        v-if="!purchasePrices.length"
      >
        <span>
          {{ 'No prices.'|pgettext('ProductPrices') }}
        </span>
      </BListGroupItem>
      <BListGroupItem
        :key="item.id"
        class="d-flex flex-column"
        v-for="item in purchasePrices"
      >
        <ItpBox
          alignItems="start"
        >
          <ItpIcon
            :icon="item.is_purchase_price ? 'icons8:buy' : 'material-symbols:sell-outline'"
          >
          </ItpIcon>
          <ItpBox
            direction="column"
            class="w-100"
          >
            <ItpBox
              class="W-100"
            >
              <ItpBox
                class="col-md-3"
              >
                <ItpText
                  :strikethrough="item.inactive"
                  class="font-weight-bold mr-3"
                >
                  {{ item.price|number }} {{ item.currency }}
                </ItpText>
                <UcTariffCodeBadge
                  :value="item.tariff_code"
                  class="mr-3"
                  v-if="item.tariff_code"
                >
                </UcTariffCodeBadge>
                <ItpBadge
                  :title="'From quantity'|pgettext('ProductPrice')"
                  no-box-shadow
                  variant="light"
                  class="mr-3 badge-icon border"
                  v-if="item.quantity_from"
                >
                  <ItpIcon
                    name="fa-solid:greater-than-equal"
                  >
                  </ItpIcon>
                  <ItpText
                    :text="item.quantity_from"
                    class="ml-2"
                  >
                  </ItpText>
                  <ItpText
                    :text="product.unit"
                    class="ml-1"
                  >
                  </ItpText>
                </ItpBadge>
                <ItpBadge
                  :title="'Discount price'|pgettext('ProductPrice')"
                  no-box-shadow
                  variant="warning"
                  class="mr-3 badge-icon boredr"
                  v-if="item.is_discount_price"
                >
                  <ItpIcon
                    name="mdi:discount-outline"
                  >
                  </ItpIcon>
                </ItpBadge>
              </ItpBox>
              <ItpBox
                class="col-md-3"
              >
                <UcValidityPeriod
                  :from="item.valid_from"
                  :to="item.valid_to"
                  class="pl-3"
                >
                </UcValidityPeriod>
              </ItpBox>
              <ItpBox
                alignItems="start"
                wrap-items
                class="col-md-6"
              >
                <UcCompactCompanyDisplay
                  :payload="item.partner"
                  class="pl-3"
                  v-if="item.partner"
                >
                </UcCompactCompanyDisplay>
              </ItpBox>
            </ItpBox>
            <ItpBox
              class="W-100"
            >
              <div
                class="col-md-3"
              >
                <ItpText
                  :text="item.note"
                  pre
                  v-if="item.note"
                >
                </ItpText>
              </div>
            </ItpBox>
          </ItpBox>
          <ItpButton
            icon="fa-pen"
            :tooltip="'Edit'|gettext"
            variant="light"
            size="sm"
            class="ml-auto"
            @click.prevent.stop="evh_7972369138378646_clickPreventStop($event, {item})"
          >
          </ItpButton>
        </ItpBox>
      </BListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcProductPrices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  sortItems(...args: any[]) {
    return _.orderBy(args[0], ['valid_from', 'price'], ['desc', 'desc'])
  }

  @Prop({
    required: true,
    type: Object,
  })
  product!: object;

  @Watch('product')
  onProduct(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("product")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_product_price', { parameters: { 'product_id': this.product.id } })
  }

  currencies!: any;
  ux!: any;
  dataMembers = ['items', 'currencies', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        currencies: ["HUF"
          ,
          "EUR"
          ,
          "USD"
          ,
        ]
        ,
        ux: {
          initialLoadSpinner: true,
        }
        ,
      },
    }
  }

  get purchasePrices() {
    if (this.loaded) {

      return this.sortItems(_.filter(this.items, { is_purchase_price: true }))
    }
    return null;
  }

  get sellingPrices() {
    if (this.loaded) {

      return this.sortItems(_.filter(this.items, { is_purchase_price: false }))
    }
    return null;
  }

  async evh_3343864469950044_close_8009_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_8009, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_3343864469950044_showModal_8008_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_3343864469950044_showModal_8008, alias=undefined
    return {
      name: "ProductPrice",
      props: {
        product: this.product,
        is_purchase_price: false,
      }
      ,
    }
  }

  async evh_3343864469950044_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_8855792642156263_close_8013_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8855792642156263_close_8013, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8855792642156263_showModal_8012_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8855792642156263_showModal_8012, alias=undefined
    return {
      name: "ProductPrice",
      props: {
        oid: $event.scope.item.id,
        mode: "edit",
        product: this.product,
      }
      ,
    }
  }

  async evh_8855792642156263_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8855792642156263_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_302930856768608_close_8017_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_302930856768608_close_8017, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_302930856768608_showModal_8016_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_302930856768608_showModal_8016, alias=undefined
    return {
      name: "ProductPrice",
      props: {
        product: this.product,
        is_purchase_price: true,
      }
      ,
    }
  }

  async evh_302930856768608_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_302930856768608_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_7972369138378646_close_8021_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7972369138378646_close_8021, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_7972369138378646_showModal_8020_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7972369138378646_showModal_8020, alias=undefined
    return {
      name: "ProductPrice",
      props: {
        oid: $event.scope.item.id,
        mode: "edit",
        product: this.product,
      }
      ,
    }
  }

  async evh_7972369138378646_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7972369138378646_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_3343864469950044_reloadComponentData_8010: actions.ReloadComponentDataAction;
    evh_3343864469950044_close_8009: actions.EventHandlerImpl;
    act_3343864469950044_showModal_8008: actions.ShowModalAction;
    evh_3343864469950044_clickPreventStop_8007: actions.EventHandlerImpl;
    evh_3343864469950044_clickPreventStop: actions.EventHandlerGroup;
    act_8855792642156263_reloadComponentData_8014: actions.ReloadComponentDataAction;
    evh_8855792642156263_close_8013: actions.EventHandlerImpl;
    act_8855792642156263_showModal_8012: actions.ShowModalAction;
    evh_8855792642156263_clickPreventStop_8011: actions.EventHandlerImpl;
    evh_8855792642156263_clickPreventStop: actions.EventHandlerGroup;
    act_302930856768608_reloadComponentData_8018: actions.ReloadComponentDataAction;
    evh_302930856768608_close_8017: actions.EventHandlerImpl;
    act_302930856768608_showModal_8016: actions.ShowModalAction;
    evh_302930856768608_clickPreventStop_8015: actions.EventHandlerImpl;
    evh_302930856768608_clickPreventStop: actions.EventHandlerGroup;
    act_7972369138378646_reloadComponentData_8022: actions.ReloadComponentDataAction;
    evh_7972369138378646_close_8021: actions.EventHandlerImpl;
    act_7972369138378646_showModal_8020: actions.ShowModalAction;
    evh_7972369138378646_clickPreventStop_8019: actions.EventHandlerImpl;
    evh_7972369138378646_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_3343864469950044_reloadComponentData_8010 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_3343864469950044_close_8009 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_reloadComponentData_8010,
        event: "close",
        when: this.evh_3343864469950044_close_8009_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_3343864469950044_showModal_8008 = new actions.ShowModalAction(
      {
        actionArgs: this.act_3343864469950044_showModal_8008_getActionArgs,
        events: [evh_3343864469950044_close_8009],
      }
    );
    const evh_3343864469950044_clickPreventStop_8007 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_showModal_8008,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_3343864469950044_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_clickPreventStop_8007],
      }
    );
    const act_8855792642156263_reloadComponentData_8014 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8855792642156263_close_8013 = new actions.EventHandlerImpl(
      {
        action: act_8855792642156263_reloadComponentData_8014,
        event: "close",
        when: this.evh_8855792642156263_close_8013_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_8855792642156263_showModal_8012 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8855792642156263_showModal_8012_getActionArgs,
        events: [evh_8855792642156263_close_8013],
      }
    );
    const evh_8855792642156263_clickPreventStop_8011 = new actions.EventHandlerImpl(
      {
        action: act_8855792642156263_showModal_8012,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8855792642156263_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8855792642156263_clickPreventStop_8011],
      }
    );
    const act_302930856768608_reloadComponentData_8018 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_302930856768608_close_8017 = new actions.EventHandlerImpl(
      {
        action: act_302930856768608_reloadComponentData_8018,
        event: "close",
        when: this.evh_302930856768608_close_8017_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_302930856768608_showModal_8016 = new actions.ShowModalAction(
      {
        actionArgs: this.act_302930856768608_showModal_8016_getActionArgs,
        events: [evh_302930856768608_close_8017],
      }
    );
    const evh_302930856768608_clickPreventStop_8015 = new actions.EventHandlerImpl(
      {
        action: act_302930856768608_showModal_8016,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_302930856768608_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_302930856768608_clickPreventStop_8015],
      }
    );
    const act_7972369138378646_reloadComponentData_8022 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7972369138378646_close_8021 = new actions.EventHandlerImpl(
      {
        action: act_7972369138378646_reloadComponentData_8022,
        event: "close",
        when: this.evh_7972369138378646_close_8021_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_7972369138378646_showModal_8020 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7972369138378646_showModal_8020_getActionArgs,
        events: [evh_7972369138378646_close_8021],
      }
    );
    const evh_7972369138378646_clickPreventStop_8019 = new actions.EventHandlerImpl(
      {
        action: act_7972369138378646_showModal_8020,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_7972369138378646_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7972369138378646_clickPreventStop_8019],
      }
    );
    return {
      act_3343864469950044_reloadComponentData_8010,
      evh_3343864469950044_close_8009,
      act_3343864469950044_showModal_8008,
      evh_3343864469950044_clickPreventStop_8007,
      evh_3343864469950044_clickPreventStop,
      act_8855792642156263_reloadComponentData_8014,
      evh_8855792642156263_close_8013,
      act_8855792642156263_showModal_8012,
      evh_8855792642156263_clickPreventStop_8011,
      evh_8855792642156263_clickPreventStop,
      act_302930856768608_reloadComponentData_8018,
      evh_302930856768608_close_8017,
      act_302930856768608_showModal_8016,
      evh_302930856768608_clickPreventStop_8015,
      evh_302930856768608_clickPreventStop,
      act_7972369138378646_reloadComponentData_8022,
      evh_7972369138378646_close_8021,
      act_7972369138378646_showModal_8020,
      evh_7972369138378646_clickPreventStop_8019,
      evh_7972369138378646_clickPreventStop,
    }
  }
}

Vue.component("UcProductPrices", UcProductPrices);

</script>